/* eslint-disable */
import { Box, TextField, Button, FormControl, styled, Typography, Grid, CircularProgress, FormHelperText, Modal, Autocomplete } from "@mui/material";
import { useState } from "react";
import { validateString } from "../../utils/validations";
import countryList from "../../utils/countryCode.json";
import { useLazyQuery } from "@apollo/client";
import { searchRanking } from "../../gql/queries/keywordsRanking";
import { usePopup } from "../../context/commonPop";
import CloseIcon from "@mui/icons-material/Close";

const BoxWrapper = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 650,
  backgroundColor: theme.palette.background.default,
  padding: "30px 40px 40px",
  borderRadius: "16px",
  "@media screen and (max-width:600px)": {
    width: "90%",
  },
  "& .Header": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "40px",
    "& .MainHeading": {
      fontSize: "22px",
      fontWeight: 700,
      lineHeight: "1",
      color: theme.palette.text.primary,
    },
    "& svg": {
      fontSize: "24px",
      color: theme.palette.text.primary,
      cursor: "pointer",
    },
  },
  "& .SearchFilter": {
    gap: "10px",
    "@media screen and (max-width:600px)": {
      flexDirection: "column",
    },
    "& .MuiFormControl-root": {
      "& label": {
        marginBottom: "0",
        top: "50%",
        transform: "translate(14px, -50%)",
        "&.MuiInputLabel-shrink": {
          top: "0",
          transform: "translate(14px, -9px) scale(0.75)",
        },
      },
      "& .MuiFormHelperText-root": {
        position: "absolute",
        top: "40px",
        left: "0",
        color: "#FA896B",
      },
    },
    "& .BtnWrapper": {
      textAlign: "right",
      "& button": {
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
        minWidth: "auto",
        padding: "11px 20px 10px",
        lineHeight: "1",
        minWidth: "87px",
        "@media screen and (max-width:600px)": {
          width: "100%",
        },
        "& .MuiCircularProgress-root": {
          color: "#fff",
        },
      },
    },
  },
}));
const AddKeywordForm = ({ open, setOpen, domain }) => {
  const [formState, setFormState] = useState({
    countryCode: { code: "US", label: "United States", phone: "1", geoId: "2840" },
    keyword: "",
    targetDomain: domain,
  });
  const { handleOpen } = usePopup();
  const [errorState, setErrorState] = useState({
    countryCode: false,
    keyword: false,
    targetDomain: false,
  });
  const [loading, setloading] = useState(false);

  const [SEARCH_RANKING] = useLazyQuery(searchRanking, { fetchPolicy: "network-only" });

  const updateStateValues = () => {
    setOpen(false);
    setFormState({
      countryCode: { code: "US", label: "United States", phone: "1", geoId: "2840" },
      keyword: "",
      targetDomain: domain,
    });
  };

  const handleInputChange = e => {
    const { name, value } = e.target;

    const parsedValue = name === "countryCode" ? JSON.parse(value) : value;

    setFormState(prevState => ({
      ...prevState,
      [name]: parsedValue,
    }));

    if (name === "keyword" && !validateString(parsedValue)) {
      setErrorState(prevState => ({ ...prevState, keyword: false }));
    }

    if (name === "targetDomain" && !validateString(parsedValue)) {
      setErrorState(prevState => ({ ...prevState, targetDomain: false }));
    }

    if (name === "countryCode" && parsedValue.code !== "DEFAULT") {
      setErrorState(prevState => ({ ...prevState, countryCode: false }));
    }
  };

  function checkError(item) {
    const keyword = validateString(item.keyword);
    const targetDomain = validateString(item.targetDomain);
    const countryCode = item.countryCode.code === "DEFAULT";

    setErrorState({
      countryCode,
      keyword,
      targetDomain,
    });

    return keyword || targetDomain || countryCode;
  }

  function handleSubmit(e) {
    e.preventDefault();
    const check = checkError(formState);

    if (check) return;
    setloading(true);

    SEARCH_RANKING({
      variables: {
        getKeywordRankInput: {
          countryCode: formState.countryCode.code,
          geoId: Number(formState.countryCode.geoId),
          keywords: formState.keyword,
          targetDomain: formState.targetDomain,
        },
      },
      onCompleted: ({ getSearchRank }) => {
        updateStateValues();
        setloading(false);
      },
      onError: errdata => {
        updateStateValues();
        setloading(false);
        handleOpen(true, errdata.message);
      },
      nextFetchPolicy: "network-only",
    });
  }

  return (
    <Modal
      open={open}
      onClose={() => {
        updateStateValues();
      }}
    >
      <BoxWrapper>
        <Box className="Header">
          <Typography className="MainHeading" component="h2">
            Add keyword
          </Typography>
          <CloseIcon
            onClick={() => {
              updateStateValues();
            }}
            titleAccess="Close"
          />
        </Box>
        <Box className="SearchFilter">
          <Grid container spacing={2} sx={{ alignItems: "center", justifyContent: "space-between" }}>
            <Grid item xs={12} md={6}>
              <FormControl sx={{ minWidth: "100%" }}>
                <Autocomplete
                  options={countryList.filter(option => option.code !== "DEFAULT")}
                  getOptionLabel={option => option?.label || ""}
                  value={formState.countryCode || null}
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: {
                        name: "countryCode",
                        value: newValue ? JSON.stringify(newValue) : null,
                      },
                    });
                  }}
                  isOptionEqualToValue={(option, value) => option?.code === value?.code}
                  clearIcon={formState.countryCode?.code === "DEFAULT" ? null : undefined}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Select geo location
                  "
                      error={!!errorState.countryCode}
                    />
                  )}
                />
                {errorState.countryCode && <FormHelperText>Please select geo location</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  id="targetDomain"
                  name="targetDomain"
                  value={formState.targetDomain}
                  label="Enter domain"
                  onChange={handleInputChange}
                  required
                  error={errorState.targetDomain}
                  helperText={errorState.targetDomain && "Please enter domain"}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  id="keyword"
                  name="keyword"
                  label="Enter comma separated keyword"
                  variant="outlined"
                  required
                  value={formState.keyword}
                  onChange={handleInputChange}
                  error={errorState.keyword}
                  helperText={errorState.keyword && "please enter keyword"}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Box className="BtnWrapper">
                <Button type="submit" onClick={handleSubmit}>
                  {loading ? <CircularProgress size={14} /> : "Submit"}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </BoxWrapper>
    </Modal>
  );
};

export default AddKeywordForm;
